export default {
	edit: 'Modifica',
	delete: 'Elimina',
	enable: 'Attiva per questo scenario',
	disable: 'Disattiva per questo scenario',
	next_step: 'Prossimo passo',
	skip: 'Salta',
	finish_review: 'Termina la revisione',
	skip_review: 'Salta la verifica',
	view: 'Visualizza dettagli',
	close: 'Chiudi',
	cancel: 'Annulla',
	send: 'Invia',
	clone: 'Clona',
	open: 'Apri',
	sign_out: 'Disconnetti',
	search: 'Cerca',
	save: 'Salva',
	sort_by_name: 'Ordina per nome (A→Z)',
	sort_by_importance: 'Ordina per importanza (alta→bassa)',
	filter_positive: 'Filtra parti interessate positive',
	filter_negative: 'Filtra parti interessate negative',
	export: {
		excel: 'Esporta come file Excel',
		image: 'Esporta visualizzazione come immagine'
	},
	click_to_select: 'Clicca per selezionare',
	click_to_drag: 'Trascina e rilascia per spostare',
	confirm_drop: {
		message_baseline:
			'Stai aggiornando la baseline, confermi le modifiche?',
		message_scenario:
			'Stai aggiornando lo scenario {{scenarioName}}, confermi le modifiche?',
		likelihood: 'Probabilità',
		impact: 'Impatto',
		before: 'Prima',
		after: 'Dopo'
	}
};
